import React from 'react'
import { Icon } from "@material-ui/core";
import KubeappsLogo from './kubeapps.png'

export const KubeappsIcon = () => (
    React.createElement(Icon, null
        , React.createElement('img', { src: KubeappsLogo, alt: "",  height: 25, width: 25,})
    )
)